export default "__VITE_ASSET__0fcd75d3__"